export var defaultProps = {
  data: [{
    id: 'accordion 1',
    title: {
      text: 'What is eSIM or eSIM card?'
    },
    content: {
      dataArray: [{
        content: [{
          text: 'An eSIM is an online extension of your regular SIM card. This SIM can be downloaded and exists as a digital version. With an eSIM card, you will no longer need to have access to the physical SIM card of your phone.',
          type: 'body-para-sm'
        }]
      }]
    }
  }, {
    id: 'accordion 2',
    title: {
      text: 'What are the benefits of Airtel eSIM card?'
    },
    content: {
      dataArray: [{
        content: [{
          text: 'With Airtel eSIM card by your side, you will no longer have to be dependent upon your physical SIM card. Therefore, even when your phone gets damaged, you can easily download the eSIM on your new mobile phone. The transition will be effortless.',
          type: 'body-para-sm'
        }]
      }, {
        content: [{
          text: 'The launch date for the new MNP process is 16-Dec-2019.',
          type: 'body-para-sm'
        }, {
          text: 'The launch date for the new MNP process is 16-Dec-2019',
          type: 'body-para-sm'
        }, {
          text: 'view more',
          type: 'body-para-sm'
        }]
      }]
    }
  }, {
    id: 'accordion 3',
    title: {
      text: 'Can we convert physical sim to eSIM?'
    },
    content: {
      dataArray: [{
        content: [{
          text: 'Yes, of course! It is very easy to convert a physical SIM into an eSIM. Send an SMS to 121 with ?esim<>registered email ID?, reply to the SMS that you receive back within a minute. Then, proceed to step 2 where you?ll provide your consent. Then you will receive a QR code, which you will have to scan and finally, you?ll be able to download your eSIM.',
          type: 'body-para-sm'
        }]
      }]
    }
  }, {
    id: 'accordion 4',
    title: {
      text: 'How to activate eSIM in smartphone?'
    },
    content: {
      dataArray: [{
        content: [{
          text: 'Once you have received the QR code in your smartphone, make sure to scan it. Moreover, remember to scan your eSIM card QR code as soon as you receive it in your registered mail ID. Once the eSIM is downloaded, it will be activated automatically.',
          type: 'body-para-sm'
        }]
      }]
    }
  }, {
    id: 'accordion 5',
    title: {
      text: 'How to activate eSIM in smartwatch?'
    },
    content: {
      dataArray: [{
        content: [{
          text: 'To activate eSIM on your smartwatch, make sure it is paired to your smartphone. Now open the smartwatch app on your smartphone, activate the wireless service on your smartwatch and wait till the syncing is completed. Your smartwatch with eSIM is now activated.',
          type: 'body-para-sm'
        }]
      }]
    }
  }, {
    id: 'accordion 6',
    title: {
      text: 'Which devices are compatible for Airtel eSIM?'
    },
    content: {
      dataArray: [{
        content: [{
          text: 'Any devices that support an eSIM feature are compatible for Airtel eSIM, so you need not worry. You can choose from Apple?s iPhone, Google?s Pixel smartphones, Samsung, and Motorola devices when it comes to compatibility for your new Airtel eSIM card.',
          type: 'body-para-sm'
        }]
      }]
    }
  }, {
    id: 'accordion 7',
    title: {
      text: 'How much time will it take to activate eSIM?'
    },
    content: {
      dataArray: [{
        content: [{
          text: 'The Airtel eSIM card usually takes up to two hours for activation. During this period, your existing physical card will continue to work. One important thing to note here is that you need to scan the QR code immediately on receiving the receipt.',
          type: 'body-para-sm'
        }]
      }]
    }
  }, {
    id: 'accordion 8',
    title: {
      text: 'How to activate eSIM in iPhone or iOS?'
    },
    content: {
      dataArray: [{
        content: [{
          text: 'To activate your eSIM card on your Apple device, you need to follow the steps mentioned below:',
          type: 'body-para-sm'
        }]
      }, {
        prefix: {
          text: '1',
          type: 'body-para-sm',
          prefixAlign: 'left'
        },
        content: [{
          text: 'Go to ?Settings? and press on the ?Mobile data? option',
          type: 'body-para-sm'
        }]
      }, {
        prefix: {
          text: '2',
          type: 'body-para-sm',
          prefixAlign: 'left'
        },
        content: [{
          text: 'Add a data plan',
          type: 'body-para-sm'
        }]
      }, {
        prefix: {
          text: '3',
          type: 'body-para-sm',
          prefixAlign: 'left'
        },
        content: [{
          text: 'Check your email and scan the QR code sent to your registered email address',
          type: 'body-para-sm'
        }]
      }, {
        prefix: {
          text: '4',
          type: 'body-para-sm',
          prefixAlign: 'left'
        },
        content: [{
          text: 'Scan the code once again and press ?Add data plan?',
          type: 'body-para-sm'
        }]
      }, {
        prefix: {
          text: '5',
          type: 'body-para-sm',
          prefixAlign: 'left'
        },
        content: [{
          text: 'Choose the data plan labels as your needs registered email address',
          type: 'body-para-sm'
        }]
      }, {
        prefix: {
          text: '6',
          type: 'body-para-sm',
          prefixAlign: 'left'
        },
        content: [{
          text: 'Select ?Continue? to activate the eSIM card.',
          type: 'body-para-sm'
        }]
      }]
    }
  }, {
    id: 'accordion 9',
    title: {
      text: 'E sim QR Code not received on registered email ID?'
    },
    content: {
      dataArray: [{
        content: [{
          text: 'If an Airtel prepaid user hasn?t received the QR code on the registered email ID, it is important to send a text message to the following numbers:',
          type: 'body-para-sm'
        }]
      }, {
        prefix: {
          text: '1',
          type: 'body-para-sm',
          prefixAlign: 'left'
        },
        content: [{
          text: 'NESIM to 52212 (for numbers in Andhra Pradesh, Telangana, Kerala, Tamil Nadu, and Karnataka)',
          type: 'body-para-sm'
        }]
      }, {
        prefix: {
          text: '2',
          type: 'body-para-sm',
          prefixAlign: 'left'
        },
        content: [{
          text: 'NESIM to 51619 (for numbers in the rest of India).',
          type: 'body-para-sm'
        }]
      }, {
        content: [{
          text: 'But, if you?re an Airtel postpaid user who hasn?t received the code, send NOSIM to 121.',
          type: 'body-para-sm'
        }]
      }]
    }
  }, {
    id: 'accordion 10',
    title: {
      text: 'How to remove or disable my eSIM card?'
    },
    content: {
      dataArray: [{
        content: [{
          text: 'If an Airtel prepaid user hasn?t received the QR code on the registered email ID, it is important to send a text message to the following numbers:',
          type: 'body-para-sm'
        }]
      }, {
        prefix: {
          text: '1',
          type: 'body-para-sm',
          prefixAlign: 'left'
        },
        content: [{
          text: 'NESIM to 52212 (for numbers in Andhra Pradesh, Telangana, Kerala, Tamil Nadu, and Karnataka)',
          type: 'body-para-sm'
        }]
      }, {
        prefix: {
          text: '2',
          type: 'body-para-sm',
          prefixAlign: 'left'
        },
        content: [{
          text: 'NESIM to 51619 (for numbers in the rest of India).',
          type: 'body-para-sm'
        }]
      }, {
        content: [{
          text: 'But, if you?re an Airtel postpaid user who hasn?t received the code, send NOSIM to 121.',
          type: 'body-para-sm'
        }]
      }]
    }
  }]
};